import HandshqApp from 'handshq-app/handshq-app';

HandshqApp.EditableContent = function (contentWrappers) {
  if (this instanceof HandshqApp.EditableContent) {
    const _this = this;

    this.contentWrappers = contentWrappers;

    this.setup = function () {
      _this.contentWrappers.each((_index, elements) => {
        setupElements(
          elements,
          '.editable-content .editable-textarea',
          _this.setupRichTextArea,
        );
      });

      return this;
    };

    this.setupRichTextArea = function () {
      new HandshqApp.EditableTextarea({
        node: this,
        successCallback: richTextSuccessCallback,
        cancelCallback: richTextCancelCallback,
      }).setup();
    };

    function setupElements(elements, selector, callback) {
      $(elements)
        .find(selector)
        .each(function () {
          callback.call(this);
        });
    }

    function richTextSuccessCallback(editableTextarea, _response) {
      editableTextarea.submitButton.removeAttr('disabled');
      editableTextarea.richTextActions.hide();
    }

    function richTextCancelCallback(editableTextarea) {
      const original = editableTextarea.textField.val();
      editableTextarea.richTextEditor.setContent(original);
      editableTextarea.richTextActions.hide();
    }
  } else {
    throw new Error('HandshqApp.EditableContent invoked without new');
  }
};
